import { createFileRoute } from "@tanstack/react-router";

import { SKUStoreReviewPage } from "@/features/SKUStore/SKUStoreReviewPage";

export const Route = createFileRoute("/_auth/sku-store/$siteId/$skuId/reviews")(
  {
    component: SKUStoreReviewPage,
  },
);
